module.exports = __webpack_public_path__ + "materialdesignicons-webfont.b8695cc16b97f1bd9744.eot";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.eot?v=1.8.36
// module id = ../../../../../theme/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.eot?v=1.8.36
// module chunks = styles